const AlumniData = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152739/Alumnis/Layer_1_copy_jn78sa.jpg",
    name: "Awadhesh Kumar Singh",
    post: "President (Aequitas veritas Industrial Services)",
    in: "",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152741/Alumnis/Layer_2_copy_qyhpug.jpg",
    name: "Rajeev Chaba",
    post: "President & MD (MG Motor India Pvt. Ltd.)",
    in: "",
  },
  {
    id: 3,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_3_copy_nqof5r.jpg",
    name: "Hemant Agarwal",
    post: "CEO (Metamorphosis Engitech india Pvt. Ltd.",
    in: "",
  },
  {
    id: 4,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_4_copy_olwbav.jpg",
    name: "Brij N. Singh",
    post: "Technical Fellow (John Deere)",
    in: "",
  },
  {
    id: 5,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152741/Alumnis/Layer_5_copy_akzh0p.jpg",
    name: "Nalin Kapoor",
    post: "CEO (Carandbike.Com)",
    in: "",
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152741/Alumnis/Layer_6_copy_fepthb.jpg",
    name: "Dr. Jitendra Mohan Bhardwaj",
    post: "Chief Information Security Officer | Business Head - Cyber Security (TATA Advanced Systems Limited)",
    in: "",
  },
  {
    id: 7,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658156906/faculty/sajjan_ci15gn.jpg",
    name: "Sajjan K.",
    post: "Managing Director (Nikkon India)",
    in: "",
  },
  {
    id: 8,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152739/Alumnis/Layer_8_copy_i88tm4.jpg",
    name: "Rajesh Srivastava",
    post: "Habit Champion & Director (Wipro Technologies)",
    in: "",
  },
  {
    id: 9,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_9_copy_xukvpr.jpg",
    name: "Mohit Agarwal",
    post: "IG Kanpur (Range) (IPS 1997)",
    in: "",
  },
  {
    id: 10,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152739/Alumnis/Layer_10_copy_gx9vm0.jpg",
    name: "R M Agarwal",
    post: "Deputy Director General (Department of Telecommunications, Govt. of India)",
    in: "",
  },
  {
    id: 11,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_11_copy_nifwap.jpg",
    name: "Vivek Pachauri",
    post: "Head-contract Management (Baker Hughes)",
    in: "",
  },
  {
    id: 12,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152739/Alumnis/Layer_12_copy_pp2plw.jpg",
    name: "Rajneesh Agarwal",
    post: "Vice-President (Escorts-Agri & Construction)",
    in: "",
  },
  {
    id: 13,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152739/Alumnis/Layer_13_copy_yta6un.jpg",
    name: "Vikas Kapoor",
    post: "Managing Director (Deloitte)",
    in: "",
  },
  {
    id: 14,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_14_copy_fsjlum.jpg",
    name: "Neeraj Bisht",
    post: "Engineering Head (GE Digital Grid)",
    in: "",
  },
  {
    id: 15,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1676965162/T_P%20Site/851f5ac9941d720844d143ed9cfcf60a_77770ef9563500a3bc4ad1df80280437_thumb_sgwfxa.jpg",
    name: "Gopal Mishra",
    post: "Project Manager (UPPCL)",
    in: "",
  },

  {
    id: 16,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152741/Alumnis/Layer_16_copy_vpm0qa.jpg",
    name: "Nitesh Gautam",
    post: "Director of Engineering (ARM)",
    in: "",
  },
  {
    id: 17,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152739/Alumnis/Layer_17_copy_rnj9xx.jpg",
    name: "Himanshu Mishra",
    post: "Vice-President (Holcim)",
    in: "",
  },
  {
    id: 18,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095643/alumini-photos/Mukul_Sharma_sir_rlbzot.png",
    name: "Mukul Sharma",
    post: "Strategic Initiatives, Google Business Unit (Tata Consultancy Services)",
    in: "https://www.linkedin.com/in/sharmamukul/",
  },
  {
    id: 19,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095645/alumini-photos/Pawan_Tripathi_sir_kqmaxj.png",
    name: "Pawan Tripathi",
    post: "Managing Director (GeoCon Infra Pvt Ltd)",
  },
  {
    id: 20,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_15_copy_esexds.jpg",
    name: "Vinay Prajapati",
    post: "C0-Founder & CEO (Propdial)",
    in: "",
  },
  {
    id: 21,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095648/alumini-photos/Manoj_Jain_sir_lleyu0.png",
    name: "Manoj Jain",
    post: "Head TSG Cloud and DC Services (Cloud & Infrastructure Services, iCORE Wipro Technologies)",
    in: "https://www.linkedin.com/in/manoj-jain-9563022/",
  },
  {
    id: 22,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095646/alumini-photos/Mohd_Ehteshamul_Haque_sir_gmqjq3.png",
    name: " Mohd Ehteshamul Haque",
    post: "Sr. VP & Business Leader - Healthcare & Medical Devices (Wipro Limited)",
    in: "",
  },
  {
    id: 23,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095647/alumini-photos/Rashmi_Chaudhary_mam_yoggma.png",
    name: "Rashmi Chaudhary",
    post: "Senior Software Engineer (Amazon)",
    in: "",
  },
  {
    id: 24,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095647/alumini-photos/Randhir_sir_vdwtpc.png",
    name: "Randhir Singh",
    post: "Joint CEO (APAC Financial Services Pvt Ltd)",
    in: "https://www.linkedin.com/in/randhir-singh-3950b27/",
  },
  {
    id: 25,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/t_Profile/v1659095647/alumini-photos/Pawan_sir_poa6y4.png",
    name: "Pawan Pundir",
    post: "Engineering Manager (Flipkart)",
    in: "https://www.linkedin.com/in/pawanpundir/",
  },
  {
    id: 26,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1676965390/T_P%20Site/851f5ac9941d720844d143ed9cfcf60a_eec44e6b407ae7d9d4d7c8eede178a0c_thumb_noow4i.jpg",
    name: "Rohit Kamal Saxena",
    post: "Architect (Flipkart)",
    in: "https://www.linkedin.com/in/rksaxena1/",
  },
  {
    id: 27,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1676965489/T_P%20Site/1663040271736_grusac.jpg",
    name: "Ram Chandel",
    post: "Partner/Principal (Deloitte Consulting)",
    in: "https://www.linkedin.com/in/ramchandel/",
  },
  {
    id: 28,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1658152740/Alumnis/Layer_18_copy_fxjczh.jpg",
    name: "Mudit Srivastava",
    post: "Vice-President (JP Morgan)",
    in: "",
  },
  {
    id: 29,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1660036412/T_P%20Site/vishal-singh-profile-image_zw6fnv.png",
    name: "IAS Vishal Singh",
    post: "Municipal Commissioner - Ayodhya & Vice Chairman - Ayodhya Development Authority",
    in: "https://www.linkedin.com/in/vishalsinghias/",
  },
  {
    id: 30,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1660035849/T_P%20Site/WhatsApp_Image_2022-05-28_at_10.26.31_AM_ibzjpl.jpg",
    name: "IAS Anjani Kumar Singh",
    post: "Director (UP Mandi Parishad)",
    in: "",
  },
  {
    id: 31,
    image:
      "https://res.cloudinary.com/daxilgrvn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1660035849/T_P%20Site/WhatsApp_Image_2022-05-30_at_10.41.29_AM_gor1qy.jpg",
    name: "R.P. Singh",
    post: "President (Hindaclo Industries)",
    in: "",
  },
  {
    id: 32,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677038994/img1_xrm34g.jpg",
    name: "Arpita Khanna",
    post: "Fraud Technologies Manager (City National Bank)",
    in: "",
  },
  {
    id: 33,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677044021/img2_zz7ghi.jpg",
    name: "Paripurna Pandey",
    post: "Head of Engineering (GE Transportation)",
    in: "https://www.linkedin.com/in/paripurna-pandey-3b15381/",
  },
  {
    id: 34,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677044289/img3_w69zlu.jpg",
    name: "Pankaj Mishra",
    post: "Technical Lead (Atlassian)",
    in: "",
  },
  {
    id: 35,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677044401/img4_e2xb10.jpg",
    name: "Sadhana Singh",
    post: "Electrical Engineer (Doosan Power System India Private Limited)",
    in: "",
  },
  {
    id: 36,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677044537/img5_w1dbdi.jpg",
    name: "Abhimanyu Dandapani",
    post: "Technical Program Manager (Google)",
    in: "",
  },
  {
    id: 37,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677044653/img6_re3uyi.jpg",
    name: "Vaibhav Narain",
    post: "Director of Platform Operations & Head of Customer Success (BetterPlace)",
    in: "",
  },
  {
    id: 38,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677045361/img7_dr4wxf.jpg",
    name: "Anshuman Singh",
    post: "Director - Freight, Warehouse and Customer Success (Jusda India SCM - Foxconn Technology Group)",
    in: "",
  },

  {
    id: 39,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677046300/img8_ukcrop.jpg",
    name: "Amit Pandey",
    post: "Senior Software Engineering Manager (Meta)",
    in: "",
  },
  {
    id: 40,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677046559/img9_cpkb5b.jpg",
    name: "Sumit Pradhan",
    post: "Manager, Statistical Programming (Syneos Health)",
    in: "",
  },
  {
    id: 41,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677046692/img10_cautpp.jpg",
    name: "Sanjay Tyagi",
    post: "Executive Director (United Engineers Limited)",
    in: "",
  },
  {
    id: 42,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677046819/img11_cwqudq.jpg",
    name: "Vikas Rungta",
    post: "Founder and CEO (Ravity Software Solutions Pvt. Ltd.)",
    in: "",
  },
  {
    id: 43,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677046941/img12_hixl5y.jpg",
    name: "Akhil Kumar",
    post: "Founder, CEO (Apra Labs)",
    in: "",
  },
  {
    id: 44,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677047087/img13_o6lkev.jpg",
    name: "Shafali Agarwal",
    post: "Vice President (Citi)",
    in: "",
  },
  {
    id: 45,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677047328/img14_vxrcdd.jpg",
    name: "Rajesh Gupta",
    post: "Engineering Leader (Amazon Web Services)",
    in: "",
  },
  {
    id: 46,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677047604/img15_rxlp6u.jpg",
    name: "Aparna Srivastava",
    post: "Associate Director Engineering (Standard Chartered Research and Technology)",
    in: "",
  },
  {
    id: 47,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677047711/img16_vi2ntx.jpg",
    name: "Prashant Srivastava",
    post: "Senior Technology Manager (Infosys)",
    in: "",
  },
  {
    id: 48,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677047806/img17_wt1sgb.jpg",
    name: "Dr. Monica Mehrotra",
    post: "Director (BBD Engineering College)",
    in: "",
  },
  {
    id: 49,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677047950/img18_lnrdqp.jpg",
    name: "Dr. Vinay Kumar Patel",
    post: "Controller of Examination (Uttarakhand Technical University)",
    in: "",
  },
  {
    id: 50,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677048081/img19_bh3tqt.jpg",
    name: "Shomi Arora",
    post: "Engineering Leader of Leaders (Stripe)",
    in: "",
  },
  {
    id: 51,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677048248/img20_y9yzyt.jpg",
    name: "Ajay Kumar Nagpal",
    post: "General Manager (Bharat Heavy Electricals Limited)",
    in: "",
  },
  {
    id: 52,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677088684/img1_x3asqy.jpg",
    name: "Aastha Garg",
    post: "Founder (WorkGeek)",
    in: "",
  },
  {
    id: 53,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677088766/img2_czayp6.jpg",
    name: "Somnath Pal",
    post: "Art Director (ReDefine)",
    in: "",
  },
  {
    id: 54,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677088864/img3_lj3pp7.jpg",
    name: "Puneet Verma",
    post: "Associate Director (Nagarro)",
    in: "",
  },
  {
    id: 55,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089119/img4_kld6lz.jpg",
    name: "Alok Vajpayee",
    post: "Manager (PwC Acceleration Centers)",
    in: "",
  },
  {
    id: 56,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089301/img5_eccy4q.jpg",
    name: "Ashi Kapoor",
    post: "Director (Department of Telecommunications)",
    in: "",
  },
  {
    id: 57,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089402/img6_rvteqr.jpg",
    name: "Raj Vimal",
    post: "Assistant Vice President (Deutsche Bank)",
    in: "",
  },
  {
    id: 58,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089494/img7_eb7awv.jpg",
    name: "Ateet Pandey",
    post: "Assistant Engineer (Ministry of Defense)",
    in: "",
  },
  {
    id: 59,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089600/img8_db4xag.jpg",
    name: "Manish Dayal",
    post: "Head-Production & Maintenance (Bharat Heavy Electricals Limited)",
    in: "",
  },
  {
    id: 60,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089756/img9_li6lro.jpg",
    name: "Kriti Chitranshi",
    post: "Visualisation Development Manager (Scentre Group (Owner and Operator of Westfield in Aus and NZ))",
    in: "",
  },
  {
    id: 61,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677089892/img10_rivi3n.jpg",
    name: "Anil K Vishwakarma",
    post: "Director - Sr. Delivery Partner Executive (Kyndryl)",
    in: "",
  },
  {
    id: 62,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090005/img11_copctt.jpg",
    name: "Ashish Kulshreshtha",
    post: "Senior Engineering Manager (Flipkart)",
    in: "",
  },
  {
    id: 63,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090109/img12_dv1zt4.jpg",
    name: "Prakash Barnwal",
    post: "Software Architect (Cadence Design Systems)",
    in: "",
  },
  {
    id: 64,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090385/img13_xcysu2.jpg",
    name: "Rajesh Kumar",
    post: "Director (Wishmed Pty Ltd)",
    in: "",
  },
  {
    id: 65,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090481/img14_sj1s5v.jpg",
    name: "Preeti Yadav",
    post: "Vice President (Wells Fargo)",
    in: "",
  },
  {
    id: 66,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090576/img15_gnj2iv.jpg",
    name: "Astha Tandon",
    post: "Senior Technical Specialist (Brillio)",
    in: "",
  },
  {
    id: 67,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090647/img16_kp7ucz.jpg",
    name: "Meenakshi Pachoria",
    post: "Founder & Chief Operating Officer (Meenaz Fashion)",
    in: "",
  },
  {
    id: 68,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090736/img17_ixcun7.jpg",
    name: "Sushil Arya",
    post: "Assistant General Manager (Airports Authority of India)",
    in: "",
  },
  {
    id: 69,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090820/img18_qjiph0.jpg",
    name: "Pradeep Yadav",
    post: "Deputy Manager (Mawana Sugars Ltd)",
    in: "",
  },
  {
    id: 70,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677090901/img19_q7pld1.jpg",
    name: "Navin Upreti",
    post: "Director (Trabs International Pvt Ltd)",
    in: "",
  },
  {
    id: 71,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677091001/img20_xsamml.jpg",
    name: "Manoj Sharma",
    post: "Director (MicroSave)",
    in: "",
  },
  {
    id: 72,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091919/alumini-photos/Amit_Barnawal_rkifmn.jpg",
    name: "Amit Barnawal",
    post: "Technical Architect (Cognizant)",
    in: "https://www.linkedin.com/in/abarnawal/",
  },
  {
    id: 73,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091918/alumini-photos/Aakash_Singh_bgbn9x.jpg",
    name: "Aakash Singh",
    post: "Managing Director (M/s Shiva and Sons Agro Products)",
    in: "https://www.linkedin.com/in/aakash-singh-2234a8169/",
  },
  {
    id: 74,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091920/alumini-photos/Hemant_Chaurasia_cawxs5.jpg",
    name: "Hemant Chaurasia",
    post: "Procurement Manager (NTPC)",
    in: "https://www.linkedin.com/in/hemant-chaurasia-5416b318/",
  },
  {
    id: 75,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091920/alumini-photos/Nirbhay_Pratap_Singh_wgsx8w.jpg",
    name: "Nirbhay Pratap Singh",
    post: "Director of Engineering (Walmart Global Tech India)",
    in: "https://www.linkedin.com/in/nirbhay-pratap-singh-19009727/",
  },
  {
    id: 76,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091921/alumini-photos/Rashmi_Mishra_xk2z2o.jpg",
    name: "Rashmi Mishra",
    post: "Engineering Manager (EFI)",
    in: "https://www.linkedin.com/in/rashmi-mishra-4328025/",
  },
  {
    id: 77,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091918/alumini-photos/Ashutosh_Singh_x4dbkx.jpg",
    name: "Ashutosh Singh",
    post: "Assistant Vice President (Citi Bank)",
    in: "https://www.linkedin.com/in/ashutosh-singh-73770124/",
  },
  {
    id: 78,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091920/alumini-photos/Neelesh_K_Shukla_g0dwdb.jpg",
    name: "Neelesh K Shukla",
    post: "Principal Scientist & Coordinator - AI Innovation & Research, Manager-AI (State Street)",
    in: "https://www.linkedin.com/in/neeleshshukla/",
  },
  {
    id: 79,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091918/alumini-photos/Aman_Jain_my6bjn.jpg",
    name: "Aman Jain",
    post: "Chairman and Managing Director (Reckon Sales Pvt Ltd)",
    in: "https://www.linkedin.com/in/amanjainreckon/",
  },
  {
    id: 80,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091919/alumini-photos/Ashwani_Kumar_n2i2aj.jpg",
    name: "Ashwani Kumar",
    post: "Co-Founder (Royalzig Luxury Furniture)",
    in: "https://www.linkedin.com/in/ashwani-kumar-99077185/",
  },
  {
    id: 81,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677093155/alumini-photos/Dr._Bharat_Lohani_g0uyco.jpg",
    name: "Dr. Bharat Lohani",
    post: "Professor-IITK | Founder (Geokno)",
    in: "https://www.linkedin.com/in/bharatlohani/",
  },
  {
    id: 82,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091921/alumini-photos/Rajeev_Srivastava_ro4hqp.jpg",
    name: "Rajeev Srivastava",
    post: "Senior Technical Architect (Cognizant)",
    in: "https://www.linkedin.com/in/srivastavark/",
  },
  {
    id: 83,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091920/alumini-photos/Bhaskar_Pathak_l61buq.jpg",
    name: "Bhaskar Pathak",
    post: "Principal Architect (Larsen & Toubro Infotech)",
    in: "https://www.linkedin.com/in/bhaskarpathak/",
  },
  {
    id: 84,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091921/alumini-photos/Sunder_Singh_xswdgp.jpg",
    name: "Sunder Singh",
    post: "Senior Vice President & Chief Operating Officer (IFS India LLP & IFS India LLC)",
    in: "https://www.linkedin.com/in/sundersingh1/",
  },
  {
    id: 85,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677093037/alumini-photos/Anita_Meghani_js1ugm.jpg",
    name: "Anita Meghani ",
    post: "Technology Project and Program Manager (Wolters Kluwer)",
    in: "https://www.linkedin.com/in/anita-meghani-05a99934/",
  },
  {
    id: 86,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091918/alumini-photos/adarsh_mishra_lysllx.jpg",
    name: "Adarsh Mishra",
    post: "Senior Member of Technical Staff (Oracle)",
    in: "https://www.linkedin.com/in/adarsh-mishra-66451918/",
  },
  {
    id: 87,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091920/alumini-photos/Avinash_Mishra_y0tg4x.jpg",
    name: "Avinash Mishra",
    post: "Senior Manager (Morgan Stanley)",
    in: "https://www.linkedin.com/in/avinash-mishra-71474431/",
  },
  {
    id: 88,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091920/alumini-photos/Pankaj_Bhalla_bepxte.jpg",
    name: "Pankaj Bhalla",
    post: "Director-IT (Fiserv)",
    in: "https://www.linkedin.com/in/pankajbhalla/",
  },
  {
    id: 89,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677092395/alumini-photos/Priyam_Srivastava_urjily.jpg",
    name: "Priyam Srivastava",
    post: "Deputy Director at Central Electricity Authority, Ministry of Power",
    in: "https://www.linkedin.com/in/priyam-srivastava-36b670238/",
  },
  {
    id: 90,
    image:
      "https://res.cloudinary.com/vaish1101/image/upload/v1677091921/alumini-photos/Sanjay_Kumar_Sinha_s0xvdf.jpg",
    name: "Sanjay Kumar Sinha",
    post: "Founder and Chief Executive",
    in: "https://www.linkedin.com/in/sanjay-kumar-sinha-7a93183a/",
  },
  {
    id: 91,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677071164/Alumnis/Lalit_peaupe.jpg",
    name: "Lalit Singh ",
    post: "Addl. GM (C&I Maint.)",
    in: "https://www.linkedin.com/in/lalit-singh-b333a7187/",
  },
  {
    id: 92,
    image:
      "https://res.cloudinary.com/dd6idpm2e/image/upload/v1677130198/img_jlydub.jpg",
    name: "Sudesh Kumar Kashyap",
    post: "Chief Scientist (National Aerospace Laboratories)",
    in: "https://www.linkedin.com/in/sudesh-kumar-kashyap-98aa0724/",
  },
  {
    id: 93,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677071524/uma_kx49af.jpg",
    name: "Umakant Mishra",
    post: "Director - Data and AI (Incedo Inc.)",
    in: "https://www.linkedin.com/in/umakantpmp/",
  },
  {
    id: 94,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677071675/1657867156098_ti2c6y.jpg",
    name: "Himani Agarwal",
    post: "Senior Technical Lead (Mercedes-Benz Research and Development India)",
    in: "https://www.linkedin.com/in/himani-agarwal-84857127/",
  },
  {
    id: 95,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677071855/1583300459052_l4moaz.jpg",
    name: "Shalinee Ram",
    post: "Talent Acquisition (Valuefirst - A Twilio Company)",
    in: "https://www.linkedin.com/in/shalinee-ram-417757144/",
  },
  {
    id: 96,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677072027/hfhgvghvh_rk9buf.jpg",
    name: "Sudhir Bhargava",
    post: "CFO (Collegedekho.com)",
    in: "https://www.linkedin.com/in/sudhir-bhargava-7720527/",
  },
  {
    id: 97,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677072242/1516778487500_kkwhiw.jpg",
    name: "Pankaj Rai",
    post: "AVP (Barclays)",
    in: "https://www.linkedin.com/in/pankaj-rai-69ab3137/",
  },
  {
    id: 98,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677072588/sanjay_nes9eu.jpg",
    name: "Sanjay Garg",
    post: "Director - Program Management (Capgemini)",
    in: "https://www.linkedin.com/in/sanjay-garg-1ba6405/",
  },
  {
    id: 99,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677072720/1673533602078_d4fzta.jpg",
    name: "Ambika Srivastava",
    post: "IT Head (CCIIT)",
    in: "https://www.linkedin.com/in/ambika-srivastava-096226215/",
  },
  {
    id: 100,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677072790/naveen_sgegvi.jpg",
    name: "Naveen Tyagi",
    post: "DGM (HSM Project) (Jindal Steel)",
    in: "https://www.linkedin.com/in/naveen-tyagi-37131617b/",
  },
  {
    id: 101,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677072922/devarshi_s2ltmu.jpg",
    name: "Devarshi Kumar Mishra",
    post: "Dy. Manager-R&D (ASK FRAS-LE FRICTION PVT. LTD)",
    in: "https://www.linkedin.com/in/devarshi-mishra-88657045/",
  },
  {
    id: 102,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073050/prateek_b0nerb.jpg",
    name: "Prateesh Shukla",
    post: "Lead Analyst - Strategy and Competitive Intelligence (Baker Hughes)",
    in: "https://www.linkedin.com/in/prateesh-shukla-b945971a/",
  },
  {
    id: 103,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073190/anoop_ulepfi.jpg",
    name: "Anoop Srivastava",
    post: "Chief Environment (Tata Steel Meramandali)",
    in: "https://www.linkedin.com/in/anoop-srivastava-011b9973/",
  },
  {
    id: 104,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073291/durgesh_e7jeys.jpg",
    name: "Durgeshwar Dwivedi",
    post: "RBU Head (Apollo Tyres Ltd)",
    in: "https://www.linkedin.com/in/durgeshwar-dwivedi-32896640/",
  },
  {
    id: 105,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073368/abhi_ndsrpv.jpg",
    name: "Abhishek Jaiswal",
    post: "Vice-President (Barclays Technology Centre)",
    in: "https://www.linkedin.com/in/abhishek-jaiswal-08960325/",
  },
  {
    id: 106,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073514/rajesh_z4kzbu.jpg",
    name: "Rajesh K Chaurasia",
    post: "Master Technologist (Hewlett Packard)",
    in: "https://www.linkedin.com/in/rajeshkc/",
  },
  {
    id: 107,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073737/harish_umspeb.jpg",
    name: "Harish Srivastava",
    post: "Sr Advisory Solution Consultant (ServiceNow)",
    in: "https://www.linkedin.com/in/srivastavaharish/",
  },
  {
    id: 108,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073737/dalip_s7mip9.jpg",
    name: "Dalip Singh Negi",
    post: "Engineering Leader (Microsoft)",
    in: "https://www.linkedin.com/in/dalipnegi/",
  },
  {
    id: 109,
    image:
      "https://res.cloudinary.com/dpcpegpsn/image/upload/w_1000,c_fill,ar_1:1,g_auto,r_max,bo_5px_solid_red,b_rgb:262c35/v1677073619/sumit_peki2q.jpg",
    name: "Sumeet Kejriwal",
    post: "DGM - Service at Adonis Electronics Private Limited (Onida)",
    in: "https://www.linkedin.com/in/sumeet-kejriwal-960b7520/",
  },
];

export default AlumniData;
